import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home', active: location.pathname === '/' },
    { path: '/pricing', label: 'Get Quote', active: location.pathname === '/pricing' }
  ];

  return (
    <header className="marketplace-header">
      <div className="container">
        <div className="flex items-center justify-between w-full">
          <div 
            onClick={() => navigate('/')}
            className="cursor-pointer"
          >
            <Logo 
              size="medium" 
              showText={true}
            />
          </div>
          
          <nav className="marketplace-nav">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`marketplace-nav-link ${
                  item.active ? 'bg-gray-100' : ''
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/pricing')}
              className="btn-primary"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;